export default class Field {
    static fromData(data) {
        if (!data) {
            return;
        }

        let field = new Field();

        field.id = data.id || null;
        field.name = data.name;
        field.note = data.note;
        field.size = data.size;
        field.maxPersons = data.maxPersons;
        field.hasImage = data.hasImage;
        field.imageUrl = data.imageUrl;
        field.hierarchyPath = data.hierarchyPath;
        field.locationId = data.locationId;
        field.areaId = data.areaId;
        field.isArchived = data.isArchived;
        field.isViewable = data.isViewable;
        field.isEditable = data.isEditable;
        field.isDeletable = data.isDeletable;

        Object.seal(field);
        return field;
    }

    equals(field){
        if (field.id === null) {
            return false;
        }
        return field.id === this.id;
    }
}
